import UserListItem, { UsersList } from "./styles";
import { formatUserList } from "./model";

export default UserListItem;
export { formatUserList, UsersList };
